module.exports = __webpack_public_path__ + "img/pin.6f083b34.svg";